(function () {
  function init(root) {
    if (!(root instanceof HTMLElement)) return;
    const bar = root.querySelector(".parans-header__bar");
    const inner = root.querySelector(".parans-header__inner");
    const burger = root.querySelector("[data-parans-burger]");
    const mobile = root.querySelector("[data-parans-mobile]");
    const shopMegaItem = root.querySelector(".parans-header__nav-item--mega");
    const shopTrigger = shopMegaItem?.querySelector(".parans-header__nav-trigger");
    const dropdownItems = root.querySelectorAll(".parans-header__nav-item--dropdown");

    function closeMega() {
      if (!shopMegaItem || !shopTrigger) return;
      shopMegaItem.classList.remove("is-open");
      shopTrigger.setAttribute("aria-expanded", "false");
    }

    const announcement = root.querySelector(".parans-header__announcement");
    const barFixed = root.querySelector(".parans-header__bar--fixed");
    const placeholder = root.querySelector(".parans-header__bar-placeholder");
    let fixedBarRaf = 0;

    function syncFixedBarPlaceholder() {
      if (!(placeholder instanceof HTMLElement) || !(barFixed instanceof HTMLElement)) return;
      const h = barFixed.offsetHeight;
      placeholder.style.height = h ? `${Math.ceil(h)}px` : "";
    }

    function updateFixedBarTop() {
      if (!(barFixed instanceof HTMLElement)) return;
      /* 用户:页眉已单独改回 100% 不缩放(--pp-zoom 只作用于 main/footer)。
         页眉为自然尺寸,固定栏 top 直接取公告底,无需再 ÷zoom。 */
      let top = 0;
      if (announcement instanceof HTMLElement) {
        const bottom = announcement.getBoundingClientRect().bottom;
        if (bottom > 0) top = bottom;
      }
      barFixed.style.top = `${top}px`;
      fixedBarRaf = 0;
    }

    function scheduleFixedBarUpdate() {
      if (!(barFixed instanceof HTMLElement)) return;
      if (!fixedBarRaf) fixedBarRaf = requestAnimationFrame(updateFixedBarTop);
    }

    if (barFixed instanceof HTMLElement && placeholder instanceof HTMLElement) {
      window.addEventListener(
        "scroll",
        function () {
          scheduleFixedBarUpdate();
        },
        { passive: true }
      );
      window.addEventListener("resize", function () {
        syncFixedBarPlaceholder();
        scheduleFixedBarUpdate();
      });
      if (typeof ResizeObserver !== "undefined") {
        const roBar = new ResizeObserver(function () {
          syncFixedBarPlaceholder();
          scheduleFixedBarUpdate();
        });
        roBar.observe(barFixed);
      }
      requestAnimationFrame(function () {
        syncFixedBarPlaceholder();
        updateFixedBarTop();
      });
    }

    if (burger && mobile) {
      burger.addEventListener("click", function () {
        const open = mobile.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    // 悬浮意图：离开后延时关闭，穿越触发器与面板之间的空白死区时不立即收起
    const HOVER_CLOSE_DELAY = 180;

    if (shopMegaItem && shopTrigger) {
      let megaCloseTimer = 0;

      function openMega() {
        clearTimeout(megaCloseTimer);
        shopMegaItem.classList.add("is-open");
        shopTrigger.setAttribute("aria-expanded", "true");
      }

      function scheduleCloseMega() {
        clearTimeout(megaCloseTimer);
        megaCloseTimer = window.setTimeout(closeMega, HOVER_CLOSE_DELAY);
      }

      shopTrigger.addEventListener("click", function (event) {
        // 2026-06 用户:trigger 若是带 href 的链接(Shop→/collections/all),点击直接跳转,不拦截/不切换;
        // mega 仍由 hover(mouseenter)打开。无 href 的纯按钮才走点击切换。
        if (shopTrigger.tagName === "A" && shopTrigger.getAttribute("href")) return;
        event.preventDefault();
        const open = shopMegaItem.classList.toggle("is-open");
        shopTrigger.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) clearTimeout(megaCloseTimer);
      });

      shopMegaItem.addEventListener("mouseenter", openMega);
      shopMegaItem.addEventListener("mouseleave", scheduleCloseMega);
      shopMegaItem.addEventListener("focusin", openMega);
    }

    function placeDropdown(item) {
      if (!(item instanceof HTMLElement)) return;
      const trigger = item.querySelector(".parans-header__nav-trigger");
      const panel = item.querySelector(".parans-header__dropdown");
      if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

      const anchor = inner instanceof HTMLElement ? inner : bar;
      if (!(anchor instanceof HTMLElement)) return;
      const barRect = anchor.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      const panelWidth = panel.offsetWidth || 220;
      const minLeft = 8;
      const maxLeft = Math.max(minLeft, barRect.width - panelWidth - 8);
      const triggerCenter = triggerRect.left - barRect.left + triggerRect.width / 2;
      const proposedLeft = triggerCenter - panelWidth / 2;
      const left = Math.min(maxLeft, Math.max(minLeft, proposedLeft));
      panel.style.left = `${left}px`;
    }

    dropdownItems.forEach(function (item) {
      const trigger = item.querySelector(".parans-header__nav-trigger");
      if (!(trigger instanceof HTMLElement)) return;

      let closeTimer = 0;

      function openDropdown() {
        clearTimeout(closeTimer);
        placeDropdown(item);
        item.classList.add("is-open");
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          item.classList.remove("is-open");
        }, HOVER_CLOSE_DELAY);
      }

      trigger.addEventListener("click", function (event) {
        // 2026-06 用户:带 href 的下拉 trigger(New Arrivals→new-arrivals / About→about-us)点击直接跳转;
        // 下拉仍由 hover 打开。无 href 的(Merch Packs)才点击切换。
        if (trigger.tagName === "A" && trigger.getAttribute("href")) return;
        event.preventDefault();
        const isOpen = item.classList.contains("is-open");
        dropdownItems.forEach((other) => other.classList.remove("is-open"));
        if (!isOpen) openDropdown();
      });

      item.addEventListener("mouseenter", openDropdown);
      item.addEventListener("mouseleave", scheduleClose);
      item.addEventListener("focusin", openDropdown);
    });

    document.addEventListener("click", function (event) {
      dropdownItems.forEach(function (item) {
        if (event.target instanceof Node && !item.contains(event.target)) {
          item.classList.remove("is-open");
        }
      });

      if (!shopMegaItem || !shopMegaItem.classList.contains("is-open")) return;
      if (event.target instanceof Node && !shopMegaItem.contains(event.target)) {
        closeMega();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        if (mobile && burger && mobile.classList.contains("is-open")) {
          mobile.classList.remove("is-open");
          burger.setAttribute("aria-expanded", "false");
        }
        dropdownItems.forEach((item) => item.classList.remove("is-open"));
        closeMega();
      }
    });

    window.addEventListener("resize", function () {
      dropdownItems.forEach(function (item) {
        if (item.classList.contains("is-open")) placeDropdown(item);
      });
    });
  }

  document.querySelectorAll("[data-parans-header]").forEach(init);
})();

/* Forward the Region utility to Hextom's installed language/currency selector. */
(function () {
  function closeMobileMenu(trigger) {
    var root = trigger.closest('[data-parans-header]');
    if (!root) return;

    var mobile = root.querySelector('[data-parans-mobile]');
    var burger = root.querySelector('[data-parans-burger]');
    if (!mobile || !mobile.classList.contains('is-open')) return;

    mobile.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');

    mobile.querySelectorAll('[data-parans-drill]').forEach(function (drill) {
      drill.querySelectorAll('.parans-header__drill-panel').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-panel') === 'root');
      });
      drill.setAttribute('data-current', 'root');
      drill.scrollTop = 0;
    });
  }

  function closeHextomSelectors() {
    document.querySelectorAll('.ht-tms-selector').forEach(function (host) {
      host.classList.remove('ht-tms__duo-selector--open', 'ht-tms__duo-selector--display');
      var nativeTrigger = host.querySelector(
        '.ht-tms__duo-selector__active-item, .ht-tms-dropdown__selected, .ht-tms-single-selector'
      );
      if (nativeTrigger) nativeTrigger.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll('[data-parans-region-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function visible(element) {
    if (!(element instanceof HTMLElement)) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function openHextomSelector(trigger, attempt) {
    var selectors = Array.prototype.slice.call(document.querySelectorAll('.ht-tms-selector:not([hidden])'));
    var host = selectors.find(visible) || selectors[0];
    var tools = trigger.closest('.parans-header__tools');
    if (host && tools && host.parentElement !== tools) tools.appendChild(host);
    if (host) host.classList.add('parans-header__native-localization');
    var nativeTrigger = host && host.querySelector(
      '.ht-tms__duo-selector__active-item, .ht-tms-dropdown__selected, .ht-tms-single-selector'
    );

    if (nativeTrigger) {
      trigger.removeAttribute('aria-busy');
      if (host.classList.contains('ht-tms__duo-selector--open')) {
        host.classList.remove('ht-tms__duo-selector--open', 'ht-tms__duo-selector--display');
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      // Defer until the custom Region click has finished bubbling; otherwise
      // Hextom's outside-click listener immediately closes its own panel.
      window.setTimeout(function () {
        nativeTrigger.click();
        window.setTimeout(function () {
          var isOpen = host.classList.contains('ht-tms__duo-selector--open');
          host.classList.toggle('ht-tms__duo-selector--display', isOpen);
          trigger.setAttribute('aria-expanded', String(isOpen));
        }, 50);
      }, 0);
      return;
    }

    if ((attempt || 0) < 24) {
      trigger.setAttribute('aria-busy', 'true');
      window.setTimeout(function () { openHextomSelector(trigger, (attempt || 0) + 1); }, 250);
    } else {
      trigger.removeAttribute('aria-busy');
    }
  }

  document.querySelectorAll('[data-parans-region-trigger]').forEach(function (trigger) {
    if (trigger.dataset.paransRegionReady === 'true') return;
    trigger.dataset.paransRegionReady = 'true';
    trigger.addEventListener('click', function () {
      closeMobileMenu(trigger);
      openHextomSelector(trigger, 0);
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-parans-burger]')) return;
    closeHextomSelectors();
  });
})();

/* ===== 购物车 hover 自动展开侧窗（仅桌面 hover 设备；移动端/触屏仍点击） =====
   鼠标移入「购物车图标 .parans-header__tool--cart」→ 打开抽屉。
   只负责「打开」：移开不关闭；关闭仍走默认（点遮罩 / 关闭按钮 / Esc）。 */
(function () {
  if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  document.addEventListener("mouseover", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var cart = t.closest(".parans-header__tool--cart");
    if (!cart) return;
    var d = document.getElementById("Cart-Drawer");
    if (d && typeof d.open === "function" && !d.classList.contains("active")) d.open(cart);
  });
})();

/* ===== 购物车商品区滚动条：默认隐藏，滚动时短暂显示后自动消失 =====
   scroll 事件不冒泡，用 capture 监听整个文档，命中 .cart__contents 时加 is-scrolling，
   800ms 内无新滚动则移除（恢复隐藏）。 */
(function () {
  var timer = null;
  document.addEventListener(
    "scroll",
    function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains("cart__contents")) return;
      el.classList.add("is-scrolling");
      clearTimeout(timer);
      timer = setTimeout(function () { el.classList.remove("is-scrolling"); }, 800);
    },
    true
  );
})();

(function () {
  var selector = ".ymq-b2b-price-span[data-ymq-money], .ymq-price-span[data-ymq-money], .ymq_cart_total_price, [data-parans-money], [data-parans-hextom-raw]";
  var convertedAttributes = [
    "data-ht-price-converted",
    "data-ht-price-converted-from",
    "data-ht-price-converted-to"
  ];

  function activeCurrency() {
    var active = document.querySelector(
      ".ht-tms__duo-selector__active-item[data-value], .ht-tms-single-dropdown__container--currency .ht-tms-dropdown__selected[data-value]"
    );
    var value = active && active.getAttribute("data-value");
    var currency = value && value.split(",")[0].trim().toUpperCase();
    return /^[A-Z]{3}$/.test(currency || "") ? currency : "USD";
  }

  function parseLocalizedAmount(value) {
    var normalized = String(value || "").replace(/[^0-9,.-]/g, "");
    var lastComma = normalized.lastIndexOf(",");
    var lastDot = normalized.lastIndexOf(".");

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) normalized = normalized.replace(/\./g, "").replace(",", ".");
      else normalized = normalized.replace(/,/g, "");
    } else if (lastComma > -1) {
      var commaDecimals = normalized.length - lastComma - 1;
      normalized = commaDecimals > 0 && commaDecimals <= 2
        ? normalized.replace(/,/g, ".")
        : normalized.replace(/,/g, "");
    }

    return parseFloat(normalized);
  }

  var rateCache = {};

  function conversionRate(currency) {
    if (!currency || currency === "USD") return 1;
    if (rateCache[currency]) return rateCache[currency];

    var samples = document.querySelectorAll(
      '[data-ht-price-converted="true"][data-ht-price-converted-from][data-ht-price-converted-to]'
    );
    var bestSource = 0;
    var bestRate = NaN;

    for (var index = 0; index < samples.length; index += 1) {
      var convertedTo = samples[index].getAttribute("data-ht-price-converted-to") || "";
      var themeConvertedTo = samples[index].getAttribute("data-parans-theme-converted-to") || "";
      if (themeConvertedTo && themeConvertedTo === convertedTo) continue;

      var explicitCurrency = convertedTo.toUpperCase().match(/(?:^|[^A-Z])([A-Z]{3})(?:[^A-Z]|$)/);
      if (explicitCurrency && explicitCurrency[1] !== currency) continue;

      var source = parseFloat(samples[index].getAttribute("data-ht-price-converted-from"));
      var target = parseLocalizedAmount(convertedTo);
      if (isFinite(source) && source > bestSource && isFinite(target) && target > 0) {
        bestSource = source;
        bestRate = target / source;
      }
    }

    if (isFinite(bestRate)) rateCache[currency] = bestRate;
    if (isFinite(bestRate)) return bestRate;
    return NaN;
  }

  function formatUsdAmount(amount) {
    var numericAmount = Number(amount);
    if (!isFinite(numericAmount)) return "";

    var currency = activeCurrency();
    var rate = conversionRate(currency);
    if (currency === "USD" || !isFinite(rate)) return "$" + numericAmount.toFixed(2);

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol"
      }).format(numericAmount * rate) + " " + currency;
    } catch (error) {
      return (numericAmount * rate).toFixed(2) + " " + currency;
    }
  }

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function applyUsdAmount(element, amount) {
    if (!(element instanceof HTMLElement)) return "";

    var numericAmount = Number(amount);
    if (!isFinite(numericAmount)) return "";

    var currency = activeCurrency();
    var rate = conversionRate(currency);
    var source = numericAmount.toFixed(2);
    var formatted = formatUsdAmount(numericAmount);

    element.setAttribute("htmoney", "");
    setAttributeIfChanged(element, "data-parans-hextom-raw", String(numericAmount));

    if (currency !== "USD" && isFinite(rate)) {
      setAttributeIfChanged(element, "data-ht-price-converted", "true");
      setAttributeIfChanged(element, "data-ht-price-converted-from", source);
      setAttributeIfChanged(element, "data-ht-price-converted-to", formatted);
      setAttributeIfChanged(element, "data-parans-theme-converted-to", formatted);
      setAttributeIfChanged(element, "data-parans-theme-currency", currency);
    } else {
      convertedAttributes.forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
      element.removeAttribute("data-parans-theme-converted-to");
      element.removeAttribute("data-parans-theme-currency");
    }

    if (element.textContent !== formatted) element.textContent = formatted;
    return formatted;
  }

  window.ParansMoney = {
    activeCurrency: activeCurrency,
    applyUsdAmount: applyUsdAmount,
    formatUsdAmount: formatUsdAmount
  };

  var refreshTimer = null;

  function scheduleDynamicPriceRefresh() {
    if (refreshTimer !== null) return;

    refreshTimer = window.setTimeout(function () {
      refreshTimer = null;
      var currency = activeCurrency();
      if (currency === "USD" || !isFinite(conversionRate(currency))) return;

      document.querySelectorAll("[data-parans-hextom-raw]").forEach(function (element) {
        var rawAmount = parseFloat(element.getAttribute("data-parans-hextom-raw"));
        if (isFinite(rawAmount)) applyUsdAmount(element, rawAmount);
      });
    }, 0);
  }

  function preparePrice(element) {
    if (!(element instanceof HTMLElement) || !element.matches(selector)) return;

    var rawPrice = element.getAttribute("data-ymq-money")
      || element.getAttribute("data-parans-money-usd")
      || element.getAttribute("data-parans-hextom-raw")
      || "";
    var previousRawPrice = element.getAttribute("data-parans-hextom-raw");
    var needsRefresh = !element.hasAttribute("htmoney") || (rawPrice && rawPrice !== previousRawPrice);

    element.setAttribute("htmoney", "");
    if (rawPrice) element.setAttribute("data-parans-hextom-raw", rawPrice);

    if (rawPrice && activeCurrency() !== "USD" && isFinite(conversionRate(activeCurrency()))) {
      applyUsdAmount(element, parseFloat(rawPrice));
      return;
    }

    if (!needsRefresh) return;

    convertedAttributes.forEach(function (attribute) {
      element.removeAttribute(attribute);
    });

    if (element.childElementCount === 0) {
      element.textContent = element.textContent;
    }
  }

  function preparePrices(root) {
    if (root instanceof HTMLElement) preparePrice(root);
    if (!(root instanceof Element || root instanceof Document)) return;
    root.querySelectorAll(selector).forEach(preparePrice);
  }

  function handleTextOverwrite(parent) {
    var current = parent;

    while (current instanceof HTMLElement) {
      if (current.matches(selector) && current.hasAttribute("htmoney")) {
        var convertedText = current.getAttribute("data-ht-price-converted-to") || "";
        if (
          activeCurrency() !== "USD"
          && convertedText
          && current.hasAttribute("data-parans-hextom-raw")
          && current.textContent.trim() !== convertedText
        ) {
          current.textContent = convertedText;
        } else if (
          /^\$/.test(current.textContent.trim())
          && current.textContent.trim() !== convertedText
          && convertedAttributes.some(function (attribute) { return current.hasAttribute(attribute); })
        ) {
          convertedAttributes.forEach(function (attribute) {
            current.removeAttribute(attribute);
          });
          current.textContent = current.textContent;
        }
      }

      current = current.parentElement;
    }
  }

  preparePrices(document);

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === "attributes") {
        if (record.attributeName.indexOf("data-ht-price-converted") === 0) {
          if (record.attributeName === "data-ht-price-converted-to") scheduleDynamicPriceRefresh();
          return;
        }
        preparePrice(record.target);
        return;
      }

      if (record.type === "characterData") {
        handleTextOverwrite(record.target.parentElement);
        return;
      }

      record.addedNodes.forEach(function (node) {
        if (node instanceof Element) {
          preparePrices(node);
          return;
        }
        handleTextOverwrite(record.target instanceof HTMLElement ? record.target : record.target.parentElement);
      });

      handleTextOverwrite(record.target instanceof HTMLElement ? record.target : record.target.parentElement);
    });
  }).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      "data-ymq-money",
      "data-parans-money-usd",
      "data-ht-price-converted",
      "data-ht-price-converted-from",
      "data-ht-price-converted-to"
    ]
  });
})();
